import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import {persistStore} from 'redux-persist';
// import persistReducer from 'redux-persist/es/persistReducer';
import storage from 'redux-persist/lib/storage';
import reducers from '../reducers/index'

const persistConfig ={
    key:'root',
    storage
}
// const persistedReducer = persistReducer(persistConfig, reducers);
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, composeEnhancer(applyMiddleware(thunk)));
// const store = createStore(reducers,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), persistedReducer);



export default store;